import React from "react";
import { InMemoryDownload } from "../InMemoryDownload";
import { Release } from "../../models";
import { ReleaseFileList } from "./ReleaseFileList";

interface Props {
  releaseFiles: ReleaseFileList;
  release: Release;
}

export function Tr3SeFidoAppletFileList({ releaseFiles, release }: Props) {
  return (
    <>
      <td>
        {releaseFiles.sePackageJwtProdKeys && (
          <InMemoryDownload
            displayName="FIDO Prod Package Encrypted (JWT)"
            fileName={`fido_prod_package_encrypted.${release.version}.jwt`}
            content={releaseFiles.sePackageJwtProdKeys?.data}
          />
        )}
        {releaseFiles.seLogicJwtProdKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="FIDO Prod Logic Encrypted (JWT)"
              fileName={`fido_prod_logic_encrypted.${release.version}.jwt`}
              content={releaseFiles.seLogicJwtProdKeys?.data}
            />
          </>
        )}
        {releaseFiles.sePackageJwtDevKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="FIDO Dev Package Encrypted (JWT)"
              fileName={`fido_dev_package_encrypted.${release.version}.jwt`}
              content={releaseFiles.sePackageJwtDevKeys?.data}
            />
          </>
        )}
        {releaseFiles.seLogicJwtDevKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="FIDO Dev Logic Encrypted (JWT)"
              fileName={`fido_dev_logic_encrypted.${release.version}.jwt`}
              content={releaseFiles.seLogicJwtDevKeys?.data}
            />
          </>
        )}
      </td>
      <td />
      <td />
    </>
  );
}
